export default __webpack_public_path__ + "static/media/tented.fd6228b7.png";